import { createSlice } from "@reduxjs/toolkit";

import { logout } from "./login.reducer";

const initialState = {
  notificationTabs: "wip",
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationTabs: (state, action) => {
      state.notificationTabs = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setNotificationTabs } = notificationSlice.actions;

export default notificationSlice.reducer;

